// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","footer_content":"footer_footer_content__xo3zS"};